import { STAGE_LABELS } from "@lib/types";
import { StageBadge } from "./StageBadge";

export interface RosterStatus {
  /** "pool" or a CampaignCandidate stage. */
  status: string;
  returnedFromStage: string | null;
  returnedAt: string | null;
  /** Recorded return / rejection / withdrawal reason, shown on hover. */
  reason: string | null;
}

const POOL_CLASSES = "bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300";
const RETURNED_CLASSES = "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300";

/**
 * Status chip for a row on the campaign roster (Pool tab): "In pool",
 * "In pool · returned from Longlist <date>", or the pipeline stage badge.
 */
export function RosterStatusBadge({ status, returnedFromStage, returnedAt, reason }: RosterStatus) {
  if (status !== "pool") {
    return <StageBadge stage={status} title={reason ?? undefined} />;
  }

  if (returnedFromStage) {
    const stageLabel = STAGE_LABELS[returnedFromStage] ?? returnedFromStage;
    const date = returnedAt ? ` ${new Date(returnedAt).toLocaleDateString()}` : "";
    return (
      <span
        title={reason ?? undefined}
        className={`rounded-full px-2 py-0.5 text-[10px] font-medium ${RETURNED_CLASSES}`}
      >
        In pool · returned from {stageLabel}
        {date}
      </span>
    );
  }

  return (
    <span className={`rounded-full px-2 py-0.5 text-[10px] font-medium ${POOL_CLASSES}`}>
      In pool
    </span>
  );
}
